import React from 'react';
import { Box, Typography, alpha, useTheme } from '@mui/material';
import { Icon } from '@iconify/react';

const EmptyWatchList = () => {
  const theme = useTheme();
  
  return (
    <Box
      sx={{
        minHeight: '70vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: 3,
        p: 3,
        width: '100%',
        margin: 0
      }}
    >
      <Icon
        icon="solar:card-search-broken"
        width={64}
        height={64}
        color={alpha(theme.palette.text.secondary, 0.4)}
      />
      <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 600 }}>
        No Scripts Added
      </Typography>
      <Typography variant="body2" color="text.secondary" textAlign="center">
        Add scripts to your watchlist to track their prices
      </Typography>
    </Box>
  );
};

export default EmptyWatchList;
